import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDocuments } from '../../../ducks/calendarActions';

const useDisplayedDocumentAsset = (documentId, documentUrl, assetToAdd) => {
  const dispatch = useDispatch();
  const documents = useSelector((state) => state.calendar.data.documents || []);
  const accountCode = useSelector((state) => state.auth.data.currentUser)?.accountCode;
  const matchingDocument = documents.find((document) => document.id === documentId);
  const requestedDocument = useRef(null);

  useEffect(() => {
    const requestKey = `${accountCode}:${documentId}`;
    if (documentId && !matchingDocument && accountCode
      && requestedDocument.current !== requestKey) {
      requestedDocument.current = requestKey;
      dispatch(fetchDocuments(accountCode));
    }
  }, [accountCode, dispatch, documentId, matchingDocument]);

  const fallbackDisplayedAsset = documentId || documentUrl
    ? {
      id: documentId,
      url: documentUrl,
      name: matchingDocument?.name || 'Attached document',
      type: documentId ? 1 : 2,
    }
    : null;

  return {
    displayedAsset: assetToAdd || fallbackDisplayedAsset,
    canClear: Boolean(assetToAdd || fallbackDisplayedAsset),
  };
};

export default useDisplayedDocumentAsset;
